import { ENV } from '../../env';
import { tokenStorage } from '../utils/tokenStorage';
import type { SsoUserProfile, TokenRefreshResponse } from '../types/auth';

const AUTH_PATH = '/mopsc-app-station/api/auth';

export const authService = {
  login() {
    window.location.href = `${ENV.AUTH_BASE_URL}${AUTH_PATH}/login`;
  },

  async getMe(accessToken: string): Promise<SsoUserProfile> {
    const response = await fetch(`${ENV.AUTH_BASE_URL}${AUTH_PATH}/me`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) throw new Error('Failed to fetch user profile');
    const json = await response.json();
    return json.data as SsoUserProfile;
  },

  async refreshToken(refreshToken: string): Promise<TokenRefreshResponse> {
    const response = await fetch(`${ENV.AUTH_BASE_URL}${AUTH_PATH}/token/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
    if (!response.ok) throw new Error('Token refresh failed');
    return response.json();
  },

  async verifyProfile(
    accessToken: string,
    profile: SsoUserProfile,
  ): Promise<{ integrity_valid: boolean; mismatched_fields: string[]; message: string }> {
    const response = await fetch(`${ENV.AUTH_BASE_URL}${AUTH_PATH}/token/verify-profile`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        sub: profile.sub,
        email: profile.email,
        name: profile.name,
        entitlement_group: profile.entitlement_group,
      }),
    });
    if (!response.ok) throw new Error('Profile verification failed');
    return response.json();
  },

  logout() {
    tokenStorage.clear();
    window.location.href = `${ENV.AUTH_BASE_URL}${AUTH_PATH}/logout`;
  },
};
